import styled from '@emotion/styled';
import MuiModal from '@mui/material/Modal';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const ZoomTrigger = styled.div`
  margin-top: ${({ theme }) => theme.spacings[2]};
`;

export const TriggerButton = styled.button`
  display: inline-flex;
  align-items: center;
  padding: ${({ theme }) => `${theme.spacings[1]} ${theme.spacings[3]}`};
  border-radius: 999px;
  border: 1px solid ${({ theme }) => theme.colors.neutral40};
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.neutralMain};
  cursor: pointer;
  box-shadow: 0px 1px 3px -1px rgba(4, 13, 38, 0.12);
  transition: background 0.15s ease, box-shadow 0.15s ease, transform 0.05s ease;

  &:hover {
    background: ${({ theme }) => theme.colors.neutralLight};
    box-shadow: 0px 2px 6px -1px rgba(4, 13, 38, 0.18);
  }
  &:active {
    transform: translateY(1px);
  }
`;

export const Modal = styled(MuiModal)`
  display: flex;
  align-items: center;
  justify-content: center;

  & .MuiBackdrop-root {
    background-color: rgba(4, 13, 38, 0.7);
    backdrop-filter: blur(3px);
  }
`;

export const ModalInner = styled.div`
  position: relative;
  background: ${({ theme }) => theme.colors.white};
  width: 95vw;
  height: 95vh;
  padding: ${({ theme }) => theme.spacings[3]};
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  box-shadow: 0px 10px 40px -10px rgba(4, 13, 38, 0.5);
  animation: zoomModalIn 0.15s ease-out;

  @keyframes zoomModalIn {
    from {
      opacity: 0;
      transform: scale(0.98);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: flex-end;
  height: 32px;
  flex-shrink: 0;
`;

export const ImageArea = styled.div`
  flex: 1;
  overflow: hidden;
  display: flex;
`;

export const FullImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const Controls = styled.div`
  position: absolute;
  bottom: ${({ theme }) => theme.spacings[4]};
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacings[1]};
  padding: ${({ theme }) => theme.spacings[1]};
  background: ${({ theme }) => theme.colors.white};
  border-radius: 999px;
  box-shadow: 0px 4px 16px -2px rgba(4, 13, 38, 0.25);
  z-index: 2;
`;

export const Divider = styled.span`
  width: 1px;
  height: 24px;
  background: ${({ theme }) => theme.colors.neutral40};
`;

export const ControlButton = styled.button`
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  font-size: 1.6rem;
  line-height: 1;
  background: transparent;
  color: ${({ theme }) => theme.colors.neutralMain};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s ease, transform 0.05s ease;

  &:hover {
    background: ${({ theme }) => theme.colors.neutralLight};
  }
  &:active {
    transform: scale(0.94);
  }
`;
